import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Camera, Sparkles } from 'lucide-react';
const EVENT_PHOTOS = [{
  src: 'https://cdn.magicpatterns.com/uploads/fXcqx2BFdyf2vWjhkPrgkm/fb3.png',
  alt: 'Boda de lujo — pareja recibiendo su foto impresa',
  tag: 'Boda'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/kZXRRSTbGTh5gvpHEKS51s/photobooth_2.png',
  alt: 'Novia con su abuela — momento eterno',
  tag: 'Momento Familiar'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1q9wqpr655aKmVpqoPBg5v/c2.png',
  alt: 'Fiesta temática — disfraces y diversión',
  tag: 'Temática'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/q45BUQyUJQfsQRdLGFJyZY/WhatsApp_Image_2026-05-30_at_7.43.00_PM.jpg',
  alt: 'Quinceañera elegante — sesión editorial',
  tag: 'Quinceañera'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/6C4rukFbmsniXD22q2Eiex/c3.png',
  alt: 'Diversión total con amigos y props',
  tag: 'Fiesta'
}];
// Duplicate twice for seamless infinite scroll
const MARQUEE_PHOTOS = [...EVENT_PHOTOS, ...EVENT_PHOTOS];
export function EventGallery() {
  return <section className="py-20 md:py-24 bg-ink relative overflow-hidden border-y border-gold/10" data-id="element-133">
      {/* Ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[60%] bg-gold/5 blur-[120px] pointer-events-none" data-id="element-134"></div>

      <div className="relative z-10" data-id="element-135">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="text-center mb-12 px-4" data-id="element-136">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-gold/10 border border-gold/30 rounded-full text-gold text-sm font-medium mb-5" data-id="element-137">
            <Camera className="w-4 h-4" data-id="element-138" />
            <span data-id="element-139">Eventos reales</span>
          </div>

          <h2 className="font-serif text-3xl md:text-5xl font-bold text-cream mb-4" data-id="element-140">
            Momentos que hemos capturado
          </h2>

          <p className="font-script text-2xl md:text-3xl text-gold flex items-center justify-center gap-3" data-id="element-141">
            <Sparkles className="w-5 h-5" data-id="element-142" />
            <span data-id="element-143">Cada foto, una historia</span>
            <Sparkles className="w-5 h-5" data-id="element-144" />
          </p>
        </motion.div>

        {/* Infinite Marquee */}
        <div className="relative w-full" style={{
        WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)',
        maskImage: 'linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)'
      }} data-id="element-145">
          <motion.div className="flex gap-6 md:gap-8 w-max" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 50,
          repeat: Infinity,
          ease: 'linear'
        }} data-id="element-146">
            {MARQUEE_PHOTOS.map((photo, idx) => {
            // Subtle alternating tilt for editorial feel
            const tilt = idx % 3 === 0 ? '-rotate-1' : idx % 3 === 1 ? 'rotate-1' : '';
            return <div key={idx} className={`group relative shrink-0 w-[260px] sm:w-[300px] md:w-[340px] aspect-[3/4] rounded-2xl overflow-hidden shadow-2xl shadow-black/50 border border-gold/15 hover:border-gold/50 transition-all duration-500 hover:scale-[1.03] hover:-translate-y-2 hover:shadow-[0_20px_60px_rgba(212,175,55,0.25)] ${tilt} hover:rotate-0`} data-id="element-147">
                  <img src={photo.src} alt={photo.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" data-id="element-148" />

                  {/* Gradient overlay for tag legibility */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-90" data-id="element-149"></div>

                  {/* Tag */}
                  <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between" data-id="element-150">
                    <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-gold/95 text-ink text-xs font-bold uppercase tracking-wide rounded-full shadow-lg" data-id="element-151">
                      <Sparkles className="w-3 h-3" data-id="element-152" />
                      {photo.tag}
                    </span>
                  </div>

                  {/* Subtle inner glow on hover */}
                  <div className="absolute inset-0 ring-1 ring-inset ring-gold/0 group-hover:ring-gold/40 transition-all duration-500 rounded-2xl pointer-events-none" data-id="element-153"></div>
                </div>;
          })}
          </motion.div>
        </div>

        {/* CTA below gallery */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-center mt-12 px-4" data-id="element-154">
          <p className="text-cream/70 font-light text-base md:text-lg max-w-2xl mx-auto" data-id="element-155">
            Desde bodas elegantes hasta quinceañeras de ensueño — capturamos los
            momentos que tu familia recordará por siempre.
          </p>
        </motion.div>
      </div>
    </section>;
}